<template>
  <v-row>
    <v-col>
      <PresentationList />
    </v-col>
  </v-row>
</template>

<script>
  import PresentationList from "@/components/config/medicine/presentation/list.vue";

  export default {
    name: "PresentationConfig",
    components: {
      PresentationList,
    },
  };
</script>

<style lang="scss" scoped></style>
